var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ODataTable',{staticClass:"fixed-table dense-table",attrs:{"spec":_vm.spec,"items":_vm.rows}})}
var staticRenderFns = []

export { render, staticRenderFns }